import cx from 'classnames'

import Styles from './ProgressBar.module.scss'

interface ProgressBarProps {
  className?: string
  backgroundColor?: string
  color?: string
  percentage: number
  width: number | string
  size?: 'xs' | 'sm' | 'md' | number
}

export const ProgressBar = ({
  className,
  percentage,
  color,
  width,
  size = 'md',
  backgroundColor,
}: ProgressBarProps) => {
  const getHeight = () => {
    if (size === 'xs') {
      return 7
    } else if (size === 'sm') {
      return 10
    } else if (size === 'md') {
      return 16
    }

    return size
  }

  const height = getHeight()
  const backgroundStyles = {
    maxWidth: width,
    '--progress-bar-height': `${height}px`,
    borderRadius: height,
    backgroundColor,
  }
  const foregroundStyles = { backgroundColor: color, width: `${percentage}%` }

  return (
    <div className={cx(Styles.progressBar, {}, className)} style={backgroundStyles}>
      <div className={Styles.progress} style={foregroundStyles} />
    </div>
  )
}
